export enum AuditAction {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
    RESTORE = 'RESTORE',
    VIEW = 'VIEW',
    EXPORT = 'EXPORT',
    LOGIN = 'LOGIN',
    LOGOUT = 'LOGOUT',
    DOWNLOAD = 'DOWNLOAD',
    UPLOAD = 'UPLOAD',
    EXECUTE = 'EXECUTE',
}

export enum AuditEntityType {
    CURATION_JOB = 'CURATION_JOB',
    ONTOLOGY = 'ONTOLOGY',
    PATIENT = 'PATIENT',
    PATIENT_REGISTRY_CASE = 'PATIENT_REGISTRY_CASE',
    PATIENT_REGISTRY_PROJECT = 'PATIENT_REGISTRY_PROJECT',
    COHORT = 'COHORT',
    CALCULATION = 'CALCULATION',
    DATABASE = 'DATABASE',
    USER = 'USER',
    FILE = 'FILE',
    RESULT = 'RESULT',
    KB_ITEM = 'KB_ITEM',
    CONVERSATION = 'CONVERSATION',
}

export enum AuditStatus {
    SUCCESS = 'success',
    FAILURE = 'failure',
}

export enum AuditSource {
    SYSTEM = 'system',
    CLIENT = 'client',
    MANUAL = 'manual',
}

export interface AuditLog {
    id: string;
    user_id: string;
    user_email?: string;
    user_name?: string;
    action: AuditAction;
    entity_type: AuditEntityType;
    entity_id?: string;
    entity_name?: string;
    description?: string;
    metadata?: Record<string, any>;
    source: AuditSource;
    ip_address?: string;
    user_agent?: string;
    request_method?: string;
    request_url?: string;
    status: AuditStatus;
    error_message?: string;
    duration_ms?: number;
    created_at: string;
}

export interface AuditLogListResponse {
    logs: AuditLog[];
    total: number;
}

export interface AuditLogQuery {
    user_id?: string;
    action?: AuditAction | AuditAction[];
    entity_type?: AuditEntityType | AuditEntityType[];
    entity_id?: string;
    status?: AuditStatus | AuditStatus[];
    source?: AuditSource | AuditSource[];
    start_date?: string;
    end_date?: string;
    skip?: number;
    take?: number;
}

export interface AuditStatistics {
    total_logs: number;
    by_action: Record<string, number>;
    by_entity_type: Record<string, number>;
    by_status: Record<string, number>;
}
